import React, { useState, useEffect } from "react";
import { getIdData } from "../../../lib/studentinfo";
import { updateData } from "../../../lib/profiles";
import { useNavigate, useParams } from "react-router-dom";
import { ClassForLessonSelect, RoleSelect } from "../../ui/myselect";

export default function AdminStudentRoleUpdate() {
  const [classforLesson, setClassForLesson] = useState(9);
  const [name, setName] = useState();
  const [surname, setSurname] = useState();
  const [phone, setPhone] = useState();
  const [username, setUserName] = useState();
  const navigate = useNavigate();
  let { slug, type } = useParams();
  const [role, setRole] = useState();
  const [graduate, setGraduate] = useState();
  const [gpa, setGpa] = useState();
  const [sat, setSat] = useState();
  const [stateTest, setStateTest] = useState();
  const [major, setMajor] = useState();
  const [career, setCareer] = useState();
  const [fiveAdjectives, setFiveAdjectives] = useState();
  const [hsSchoolStatistics, setHsSchoolStatistics] = useState();
  const [topThreeColleges, setTopThreeColleges] = useState();
  const [lor, setLor] = useState();
  const [activities, setActivities] = useState();
  const [collegeEssay, setCollegeEssay] = useState();
  const [instructorNote, setInstructorNote] = useState();
  const [studentNote, setStudentNote] = useState();
  const [meetLink, setMeetLink] = useState("");
  const [folderLink, setFolderLink] = useState("");

  const [studentInfo, setStudentInfo] = useState();

  const handleSubmit = async (e) => {
    e.preventDefault();
    //console.log("school",school);

    await updateData({
      id: slug,
      phone: phone,
      class: classforLesson,
      role: role,
    });
    navigate(-1)
    //navigate(`/admin/admin-studentdetail/${slug}`);
    // navigate(`/admin/admin-studentstep3/${slug}`);
  };

  async function GetData() {
    const info = await getIdData(slug);
    console.log("info", info);
    setStudentInfo(info);
    setName(info[0].name);
    setSurname(info[0].surname);
    setClassForLesson(info[0].class);
    setRole(info[0].role);
    setUserName(info[0].username);
  }

  useEffect(() => {

     GetData();
  }, []);

  return (
    <div className="col-xl-9 col-md-8">
      <div className="settings-widget profile-details">
        <div className="settings-menu p-0">
          <div className="profile-heading">
            <h3>Update Role</h3>
          </div>
          <div className="checkout-form personal-address add-course-info ">
            <form role="form" onSubmit={handleSubmit}>
              <div className="row mx-auto">
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">Name</label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="form-control"
                      placeholder="Enter Name"
                      disabled
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">Last Name</label>
                    <input
                      type="text"
                      value={surname}
                      onChange={(e) => setSurname(e.target.value)}
                      className="form-control"
                      placeholder="Enter Last Name"
                      disabled
                    />
                  </div>
                </div>
                        <div className="col-12">
                          <div className="form-group">
                          <label className="form-control-label">
                              Role 
                            </label>
                            <RoleSelect value={role} setValue={setRole}/>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group">
                            <label className="form-control-label">
                              Class 
                            </label>
                            <ClassForLessonSelect value={classforLesson}  setValue = {setClassForLesson} name={"ClassForLessonSelect"} />
                          </div>
                        </div>
                       
               
                <div className="update-profile d-flex flex-column gap-3 flex-sm-row justify-content-between">
                  <button type="submit" className="btn btn-primary">
                    Update
                  </button>
                  <button
                    onClick={() => navigate(`/admin/admin-studentdetail/${slug}`)}
                    className="btn btn-black btn-sm update_page_cancel_btn"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

{
  /* <div className="update-profile d-flex justify-content-between">
<button type="submit" className="btn btn-primary">
  {type === "Add" ? "Next Step >>" : "Update"}
</button>
<button
  onClick={() => navigate(-1)}
  className="btn btn-black btn-sm"
>
  Cancel
</button>
</div> */
}
